"use strict";

exports.__esModule = true;
var _DeviceCycleColorSource = require("./DeviceCycleColorSource");
Object.keys(_DeviceCycleColorSource).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _DeviceCycleColorSource[key]) return;
  exports[key] = _DeviceCycleColorSource[key];
});